<template>
  <header>
    <Logo v-if='!search.active' />
    <nav v-if='!search.active'>
      <Back v-if='route.path !== "/"' :from='from' :pageToGoBackTo='pageToGoBackTo' />
      <h4 :class='{ "cart-empty": cart.itemCount === 0 }'>
        <button class='cart-btn' @click='cart.open()'>
          <span class="cart-label">Cart ({{ cart.itemCount }})</span>
          <svg class='btn-icon' viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.37212 12.049H15.3227C15.6685 12.049 15.9649 11.7498 15.9649 11.3578C15.9649 10.9555 15.6685 10.6563 15.3227 10.6563H6.50054C6.09551 10.6563 5.82878 10.3366 5.76949 9.88267L4.54447 1.07285C4.44567 0.35074 4.20857 0 3.30955 0H0.65203C0.306257 0 0 0.309479 0 0.691167C0 1.06254 0.306257 1.38233 0.65203 1.38233H3.17124L4.3765 10.058C4.55435 11.2753 5.17674 12.049 6.37212 12.049ZM4.90997 9.16055H15.3919C16.5675 9.16055 17.1899 8.38684 17.3677 7.16958L17.9704 2.96069C17.9901 2.85752 18 2.7234 18 2.65118C18 2.22824 17.6937 1.93939 17.2294 1.93939H4.29746V3.33203H16.4885L15.9846 6.99419C15.9155 7.45842 15.6685 7.77821 15.2437 7.77821H4.90009L4.90997 9.16055ZM6.85619 16C7.57739 16 8.1405 15.412 8.1405 14.6589C8.1405 13.9162 7.57739 13.3179 6.85619 13.3179C6.14491 13.3179 5.57189 13.9162 5.57189 14.6589C5.57189 15.412 6.14491 16 6.85619 16ZM14.1866 16C14.8979 16 15.4709 15.412 15.4709 14.6589C15.4709 13.9162 14.8979 13.3179 14.1866 13.3179C13.4654 13.3179 12.8924 13.9162 12.8924 14.6589C12.8924 15.412 13.4654 16 14.1866 16Z" fill="currentColor"/>
          </svg>
        </button>
      </h4>
      <h4 v-if='!(from?.params?.primi && pageToGoBackTo == from?.params?.primi)'>
        <button class='search-btn' @click='search.open()'>
          Search
          <svg class='btn-icon' viewBox="0 0 15.9175 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6.52726C0 10.1296 2.93814 13.0443 6.55669 13.0443C7.94845 13.0443 9.22679 12.6132 10.2887 11.8743L14.1237 15.7024C14.3402 15.9077 14.6082 16 14.8866 16C15.4845 16 15.9175 15.5485 15.9175 14.9532C15.9175 14.6658 15.8041 14.4092 15.6289 14.2143L11.8144 10.4067C12.6289 9.31881 13.1031 7.98462 13.1031 6.52726C13.1031 2.92495 10.1752 0 6.55669 0C2.93814 0 0 2.92495 0 6.52726ZM1.58763 6.52726C1.58763 3.78703 3.8041 1.5805 6.55669 1.5805C9.29897 1.5805 11.5258 3.78703 11.5258 6.52726C11.5258 9.25723 9.29897 11.474 6.55669 11.474C3.8041 11.474 1.58763 9.25723 1.58763 6.52726Z" fill="currentColor"/>
          </svg>
        </button>
      </h4>
      <h4 v-if='route.path !== "/"'>
        <router-link to='/' class='close-btn'>
          Close
          <svg class='btn-icon' viewBox="0 0 15.6971 16.9825" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9778 0.291074L0.285789 14.2362C-0.0889914 14.618 -0.101484 15.2922 0.285789 15.6867C0.685555 16.0811 1.33517 16.0811 1.72245 15.6867L15.4019 1.75429C15.7892 1.35986 15.8017 0.685507 15.4019 0.291074C15.0022 -0.0906366 14.365 -0.10336 13.9778 0.291074ZM15.4019 14.2362L1.72245 0.291074C1.33517 -0.0906366 0.673062 -0.10336 0.285789 0.291074C-0.0889914 0.698231 -0.0889914 1.35986 0.285789 1.75429L13.9778 15.6867C14.3525 16.0811 15.0146 16.0811 15.4019 15.6867C15.7892 15.2796 15.7892 14.618 15.4019 14.2362Z" fill="currentColor"/>
          </svg>
        </router-link>
      </h4>
    </nav>
    <div class='search-bar' v-else>
      <svg class='search-icon-left' viewBox="0 0 15.9175 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6.52726C0 10.1296 2.93814 13.0443 6.55669 13.0443C7.94845 13.0443 9.22679 12.6132 10.2887 11.8743L14.1237 15.7024C14.3402 15.9077 14.6082 16 14.8866 16C15.4845 16 15.9175 15.5485 15.9175 14.9532C15.9175 14.6658 15.8041 14.4092 15.6289 14.2143L11.8144 10.4067C12.6289 9.31881 13.1031 7.98462 13.1031 6.52726C13.1031 2.92495 10.1752 0 6.55669 0C2.93814 0 0 2.92495 0 6.52726ZM1.58763 6.52726C1.58763 3.78703 3.8041 1.5805 6.55669 1.5805C9.29897 1.5805 11.5258 3.78703 11.5258 6.52726C11.5258 9.25723 9.29897 11.474 6.55669 11.474C3.8041 11.474 1.58763 9.25723 1.58763 6.52726Z" fill="currentColor"/>
      </svg>
      <input
        ref='searchInput'
        v-model='searchQuery'
        @input='search.search(searchQuery)'
        placeholder='Search'
        type='search'
        autocomplete='off'
      />
      <button class='close-search-btn' @click='search.close()'>
        <svg class='close-circle-icon' viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38.1592 19.0869C38.1592 29.5898 29.5898 38.1592 19.0723 38.1592C8.56934 38.1592 0 29.5898 0 19.0869C0 8.56934 8.56934 0 19.0723 0C29.5898 0 38.1592 8.56934 38.1592 19.0869ZM24.8438 11.4844L19.0911 17.2119L13.3447 11.4844C13.0664 11.2207 12.7588 11.0889 12.3926 11.0889C11.6309 11.0889 11.0303 11.6602 11.0303 12.3926C11.0303 12.7734 11.1768 13.1104 11.4404 13.374L17.1805 19.1141L11.4404 24.8291C11.1768 25.1074 11.0303 25.4297 11.0303 25.7959C11.0303 26.543 11.6309 27.1436 12.3926 27.1436C12.7734 27.1436 13.0957 26.9971 13.374 26.7334L19.0869 21.0205L24.7998 26.7334C25.0635 26.9971 25.3857 27.1436 25.7812 27.1436C26.5283 27.1436 27.1289 26.543 27.1289 25.7959C27.1289 25.4297 26.9971 25.1074 26.7334 24.8291L20.9964 19.111L26.7334 13.374C26.9971 13.1104 27.1289 12.7734 27.1289 12.3926C27.1289 11.6602 26.5283 11.0889 25.7812 11.0889C25.415 11.0889 25.0928 11.2207 24.8438 11.4844Z" fill="#E0E0E0"/>
        </svg>
      </button>
    </div>
  </header>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import Logo from './Logo.vue';
import Back from './Back.vue';
import { useCartStore } from './CartStore.js';
import { useSearchStore } from './SearchStore.js';
const route = useRoute();
const cart = useCartStore();
const search = useSearchStore();
const props = defineProps(['from', 'pageToGoBackTo']);

const searchQuery = ref('');
const searchInput = ref(null);

watch(() => search.active, async (val) => {
  if (val) {
    await nextTick();
    searchInput.value?.focus();
  } else {
    searchQuery.value = '';
  }
});
</script>

<style scoped>
@import '../css/breakpoints.css';

  header {
    position: fixed;
    top: 3rem;
    left: 8.5rem;
    right: 8.5rem;
    width: var(--main-width);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index: 999;
    border-radius: 7em;
    padding: min(2rem, 20px) min(3.5rem, 48px);
    border-color: var(--light);
    border-width: 0.1rem;
    border-style: solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--light);
  }

  @media (--phone) {
    header {
      left: 2rem;
      right: 2rem;
    }

    header:deep(h4) {
      margin-left: 0.8rem;
    }

    .cart-label {
      display: none;
    }

    .cart-btn svg {
      height: 1.2em;
    }
  }

  /* Logo sizing and color */
  /* translateY compensates for the logo SVG's optical center sitting below its
     geometric center (x-height ~66% down the bounding box vs. 50%).
     overflow: visible prevents the ® symbol from being clipped by the SVG viewport. */
  header:deep(> svg) {
    height: min(3.75rem, 38px);
    transform: translateY(-12%);
    overflow: visible;
  }

  header:deep(> svg path) {
    fill: var(--light);
  }


  nav {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-size: clamp(18px, 2rem, 22px);
  }

  header:deep(h4) {
    padding: 0;
    margin: 0;
    margin-left: 18px;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    line-height: 1;
  }

  header:deep(h4 a) {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--light);
    text-decoration: none;
    line-height: 1;
  }

  .cart-empty {
    display: none;
  }

  .cart-btn,
  .search-btn,
  .close-btn,
  .close-search-btn {
    background: none;
    border: none;
    color: var(--light);
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    cursor: pointer;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
  }

  .btn-icon {
    height: 0.75em;
    width: auto;
    transform: translateY(-0.05em);
  }

  /* Search and close icons are visually thinner than the cart icon;
     scale them up to match optical weight (#77). */
  .search-btn .btn-icon {
    transform: translateY(-0.05em) scale(1.25);
  }

  /* Search bar state */
  .search-bar {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 2.2rem;
    font-size: clamp(18px, 2rem, 22px);
    height: min(3.75rem, 38px);
  }

  .search-icon-left {
    height: 1.3em;
    width: auto;
    flex-shrink: 0;
    transform: translate(-0.5em, 0);
  }

  .search-bar input {
    flex: 1;
    background: none;
    border: none;
    color: var(--light);
    font-family: 'Copernicus';
    font-size: 2.5rem;
    line-height: 1;
    letter-spacing: 0.0015em;
    outline: none;
    padding: 0;
    transform: translate(-0.5em, 0.1em);
  }

  .search-bar input::placeholder {
    font-family: 'Copernicus';
    font-size: 2.5rem;
    letter-spacing: -0.01em;
    color: var(--light);
    opacity: 1;
  }

  .search-bar input::-webkit-search-cancel-button {
    display: none;
  }

  .close-search-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    transform: translate(0.75em, -0.066em);
  }

  .close-circle-icon {
    height: 1.5em;
    width: auto;
    transform: translateY(0.04em);
  }

  @media print {
    nav {
      display: none !important;
    }
  }
</style>
